import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  
  hiddenClass = 'hidden';
  
  static targets = [
    'table',
  ];
  
    open(e) {
    const row = e.currentTarget;
    const setId = row.dataset?.setId;
    // eslint-disable-next-line max-len
    this.tableTarget.querySelector(`tbody[data-set-id="${setId}"]`).classList.toggle(this.hiddenClass);
    const expanded = !(row.getAttribute('aria-expanded') === 'true');
    row.setAttribute('aria-expanded', expanded);
    row.classList.toggle('open');
  }
}
